var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAlarmEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#5A73A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6585 12.2474C26.2429 11.8838 25.6111 11.9259 25.2474 12.3415C24.8837 12.7571 24.9259 13.3889 25.3415 13.7526C27.0903 15.2828 28 17.6147 28 20C28 22.3853 27.0903 24.7172 25.3415 26.2474C24.9259 26.6111 24.8837 27.2429 25.2474 27.6585C25.6111 28.0742 26.2429 28.1163 26.6585 27.7526C28.9096 25.7828 30 22.8647 30 20C30 17.1353 28.9096 14.2172 26.6585 12.2474ZM14.6121 23.3123C14.4232 23.1129 14.1607 23 13.8861 23H11C10.4477 23 10 22.5523 10 22V18C10 17.4477 10.4477 17 11 17H13.8852C14.1598 17 14.4223 16.8871 14.6111 16.6877L18.274 12.8214C18.8958 12.1651 20 12.6051 20 13.5091V26.4899C20 27.3939 18.8958 27.8339 18.274 27.1777L14.6121 23.3123ZM22.2191 15.3753C22.5641 14.944 23.1934 14.8741 23.6247 15.2191C26.6251 17.6195 26.6251 22.3806 23.6247 24.7809C23.1934 25.1259 22.5641 25.056 22.2191 24.6247C21.8741 24.1934 21.944 23.5641 22.3753 23.2191C24.3749 21.6195 24.3749 18.3805 22.3753 16.7809C21.944 16.4359 21.8741 15.8066 22.2191 15.3753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmEtc);
export default __webpack_public_path__ + "static/media/icon_alarm_etc.f3947ce6ad1488317051cfb2ccc14add.svg";
export { ForwardRef as ReactComponent };